import { has, isNil } from 'lodash';

interface IIdentifiable {
    [key: string]: any; // Ensures that the object has a key that can be used for identification
}

export class UniqueObjectSet<T extends IIdentifiable> {
    private items: Map<string, T>;

    private readonly propertyUsedForID: keyof T;

    constructor(key: keyof T = 'name') {
        this.items = new Map<string, T>();
        this.propertyUsedForID = key;
    }

    get size(): number {
        return this.items.size;
    }

    add(obj: T): void {
        this.validateObject(obj);
        this.items.set(String(obj[this.propertyUsedForID]), obj);
    }

    has(obj: T): boolean {
        this.validateObject(obj);
        return this.items.has(String(obj[this.propertyUsedForID]));
    }

    delete(obj: T): boolean {
        this.validateObject(obj);
        return this.items.delete(String(obj[this.propertyUsedForID]));
    }

    get(keyValue: string): T | undefined {
        return this.items.get(keyValue);
    }


    forEach(callback: (value: T, key: string, map: Map<string, T>) => void): void {
        this.items.forEach(callback);
    }

    [Symbol.iterator](): IterableIterator<T> {
        return this.items.values();
    }

    private validateObject(obj: T): void {
        if (isNil(obj) || typeof obj !== 'object' || !has(obj, this.propertyUsedForID)) {
            throw new Error(`Object must be an object and have the "${String(this.propertyUsedForID)}" property`);
        }
    }
}
